/**
 * Created by Claude on 26.01.2026
 *
 * Arkadium SDK Ads integration
 * https://arkadiumsdk.z19.web.core.windows.net/docs/features/ads
 */

const ArkadiumAds = function () {
    AdsPlugin.call(this, connector.ARKADIUM, {
        sdk: SdkManager.SDK_ARKADIUM,
        cantLoadAndPlayInParallel: true
    });

    this.interstitialSupported = false;
};

ArkadiumAds.prototype = Object.create(AdsPlugin.prototype);
ArkadiumAds.prototype.constructor = ArkadiumAds;

ArkadiumAds.prototype._connect = function (callback) {
    setTimeout(() => {
        this.interstitialSupported = true;
    }, ArkadiumAds.INTERSTITIAL_DELAY_FROM_START);

    callback(connector.STATUS_CONNECTED);
};

ArkadiumAds.isAppropriate = function () {
    return connector.platform.oneOf(connector.ARKADIUM);
};

ArkadiumAds.prototype.isNoAdsProductAvailable = function () {
    return true;
};

ArkadiumAds.prototype._playAd = function (name, ad, callback) {
    if (name === AdsPlugin.REWARDED) {
        this._playRewardedAd(callback);
    } else {
        this._playInterstitialAd(callback);
    }
};

ArkadiumAds.prototype._playRewardedAd = function (callback) {
    ArkadiumSDK.ads.showRewardAd()
        .then((response) => {
            const value = response && response.value;

            console.log("ads rewarded finished!", response);

            callback(value ? connector.CODE_SUCCEED : ERRORS.SHOW_REWARDED.UNKNOWN);
        })
        .catch((error) => {
            console.log("ads rewarded error", error);
            callback(ERRORS.SHOW_REWARDED.UNKNOWN);
        });
};

ArkadiumAds.prototype._playInterstitialAd = function (callback) {
    ArkadiumSDK.ads.showInterstitialAd()
        .then(() => {
            console.log("ads interstitial finished!");
            callback(connector.CODE_SUCCEED);
        })
        .catch((error) => {
            console.log("ads interstitial error", error);
            callback(ERRORS.SHOW_INTERSTITIAL.UNKNOWN);
        });
};

ArkadiumAds.prototype.isInterstitialSupported = function () {
    return this.interstitialSupported;
};

ArkadiumAds.prototype.isStickySupported = function () {
    return false;
};

ArkadiumAds.prototype.isStickyAvailable = function () {
    return window.innerWidth >= ArkadiumAds.AD_BANNER_WIDTH;
};

ArkadiumAds.prototype.addBannerContainer = function () {
    if (this.bannerContainer) { 
        return;
    }

    const container = this.bannerContainer = document.createElement("div");
    container.style.display = "block";
    container.style.position = "absolute";
    container.style.bottom = "0";
    container.style.margin = "0 auto";
    container.style.right = "0";
    container.style.left = "0";
    container.style.height = `${ArkadiumAds.AD_BANNER_HEIGHT}px`;
    container.style.width = `${ArkadiumAds.AD_BANNER_WIDTH}px`;
    container.style.zIndex = "2";
    container.style.backgroundColor = "white";

    const ins = this.bannerIns = document.createElement("div");
    ins.id = "arkadium-ad-banner-container";
    ins.style.zIndex = "2";
    ins.style.display = "inline-block";
    ins.style.position = "relative";
    ins.style.margin = "0 auto";
    ins.style.height = `${ArkadiumAds.AD_BANNER_HEIGHT}px`;
    ins.style.width = `${ArkadiumAds.AD_BANNER_WIDTH}px`;

    document.body.appendChild(container);
    container.appendChild(ins);
};

ArkadiumAds.prototype.removeBannerContainer = function () {
    if (this.bannerIns) {
        this.bannerIns.remove();
        this.bannerIns = undefined;
    }
    if (this.bannerContainer) {
        this.bannerContainer.remove();
        this.bannerContainer = undefined;
    }
};

ArkadiumAds.prototype.showSticky = function (callback) {
    this.addBannerContainer();

    ArkadiumSDK.ads.showBannerAd("arkadium-ad-banner-container", [ArkadiumSDK.ads.bannerSizes.AD_728x90]);

    callback(connector.CODE_SUCCEED, {
        width: ArkadiumAds.AD_BANNER_WIDTH,
        height: ArkadiumAds.AD_BANNER_HEIGHT
    });
};

ArkadiumAds.prototype.closeSticky = function (callback) {
    this.removeBannerContainer();

    callback(connector.CODE_SUCCEED);
};

ArkadiumAds.AD_BANNER_WIDTH = 728;
ArkadiumAds.AD_BANNER_HEIGHT = 90;
ArkadiumAds.INTERSTITIAL_DELAY_FROM_START = connector.utils.parseInterval("3 minutes");
